import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "recharge"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  class: "left"
};
const _hoisted_5 = {
  class: "value"
};
const _hoisted_6 = {
  class: "num"
};
const _hoisted_7 = {
  class: "add_num"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavBar = _resolveComponent("NavBar");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_dialog = _resolveComponent("van-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NavBar, {
    title: "在线充值"
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "label"
  }, "可用余额", -1)), _createElementVNode("div", _hoisted_5, [_cache[7] || (_cache[7] = _createTextVNode("¥ ")), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.amount), 1)])]), _cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "right"
  }, null, -1))]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    class: _normalizeClass(["add_item", _ctx.current === 50 && 'current']),
    "data-index": "50",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.moneyClcik(50))
  }, " 50元 ", 2), _createElementVNode("div", {
    class: _normalizeClass(["add_item", _ctx.current === 100 && 'current']),
    "data-index": "100",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.moneyClcik(100))
  }, " 100元 ", 2), _createElementVNode("div", {
    class: _normalizeClass(["add_item", _ctx.current === 300 && 'current']),
    "data-index": "300",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.moneyClcik(300))
  }, " 300元 ", 2), _createElementVNode("div", {
    class: _normalizeClass(["add_item", _ctx.current === 500 && 'current']),
    "data-index": "500",
    onClick: _cache[3] || (_cache[3] = $event => _ctx.moneyClcik(500))
  }, " 500元 ", 2), _createElementVNode("div", {
    class: "add_item",
    onClick: _cache[4] || (_cache[4] =
    //@ts-ignore
    (...args) => _ctx.otherMoney && _ctx.otherMoney(...args))
  }, "其他金额")]), _cache[11] || (_cache[11] = _createElementVNode("ul", {
    class: "tip"
  }, [_createElementVNode("li", null, "充值成功后不支持退款"), _createElementVNode("li", null, "充值金额永久有效")], -1)), _createVNode(_component_van_button, {
    class: "submit",
    color: "#5282f0",
    block: "",
    round: "",
    loading: _ctx.loading,
    "loading-text": "充值中...",
    disabled: _ctx.loading,
    onClick: _ctx.submit
  }, {
    default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode(" 充值 ")])),
    _: 1
  }, 8, ["loading", "disabled", "onClick"])]), _createVNode(_component_van_dialog, {
    show: _ctx.show,
    "onUpdate:show": _cache[6] || (_cache[6] = $event => _ctx.show = $event),
    title: "请输入金额",
    "show-cancel-button": "",
    "before-close": _ctx.customConfirm
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      class: "moneyGroup",
      border: false
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: _ctx.money,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.money = $event),
        error: _ctx.isError,
        label: "",
        type: "number",
        placeholder: "请输入金额"
      }, null, 8, ["modelValue", "error"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["show", "before-close"])]);
}